export var ProjectTypeResponse;
(function (ProjectTypeResponse) {
    ProjectTypeResponse["MONO_REPO"] = "MONO_REPO";
    ProjectTypeResponse["MULTI_REPO"] = "MULTI_REPO";
})(ProjectTypeResponse || (ProjectTypeResponse = {}));
